export default __webpack_public_path__ + "static/alex-8f03a3b7df2717cdfd5a7a6e280b5da0.jpg";